$(document).ready(function() {

    // Check for click events on the navbar burger icon
    $(".modal-button").on('click', function() {
        const $target = $(this).attr('href');
        if( $($target).hasClass('modal') ){
            $($target).toggleClass('is-active');
            $('html').toggleClass('is-clipped');
        }
        return false;
  
    });

    $(".modal-close, .modal-background").on('click', function() {
        $(this).parent().toggleClass('is-active');
        $('html').toggleClass('is-clipped');
    });

    $(document).keyup(function(e) {
        if (e.keyCode === 27){
            // esc
            $('.modal').toggleClass('is-active');
            $('html').toggleClass('is-clipped');
        }
    });

});